(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileMsTeamsMessageInfo', ["path", "$q", "mainQueueTroubleshootingHelper", "widgetPolling", "mimeIcons", "fileDao", "asteriskString", "sideMenuManager", "modulesDao", "metaInfoConverter", "rolesManager", "$interval", "commonDao", "modals", "feature", function (path, $q, mainQueueTroubleshootingHelper, widgetPolling, mimeIcons, fileDao, asteriskString, sideMenuManager, modulesDao, metaInfoConverter, rolesManager, $interval, commonDao, modals, feature) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/ms_teams_message/ms_teams-message-info').template('ms_teams-message-info'),
            scope: {},
            link: function ($scope, element, attrs) {
                var id = widgetPolling.scope().id;
                var updateTick = 30000;
                var restoreUpdateTickAfter;
                var updateWidget;
                var warningMsg = 'Viewing an message\'s data will be recorded in the audit log. Please note that ' + 'you are viewing it at your own risk as it might infringe your local privacy regulations.';
                function restartUpdating(promise, tick) {
                    if (promise) {
                        $interval.cancel(promise);
                    }
                    return $interval(function () {
                        $scope.loadData();
                    }, tick || 30000);
                }
                $scope.widgetApi = {};
                $scope.model = {};
                $scope.loadData = function () {
                    return $q.allSettled([
                        fileDao.entityInfo('ms_teams_message', id),
                        mimeIcons()
                    ]).then(function (responses) {
                        var input = {};
                        input.originData = responses[0].value && responses[0].value.data || {};
                        // info logic
                        var icons = responses[1].value;
                        var msgIcon = icons(input.originData.mimetype || 'message');
                        var msgTxt = input.originData.message_text;
                        if (!sideMenuManager.currentUser().view_private_data || sideMenuManager.hideChatMessages()) {
                            msgTxt = asteriskString(msgTxt);
                        }
                        $scope.model.info = $scope.model.info || {};
                        $scope.model.info.lines = $scope.model.info.lines || [
                            {
                                img: msgIcon,
                                class: 'profile-image'
                            },
                            {
                                text: msgTxt,
                                class: 'file-name'
                            }
                        ];
                        var queries = [modulesDao.entityInfo('ms_teams', 'ms_teams_message')];
                        var teamInfo, conversationInfo, userInfo;
                        if (input.originData && input.originData.team_id) {
                            queries.push(fileDao.entityInfo('ms_teams_team', input.originData.team_id));
                            teamInfo = queries.length - 1;
                        }
                        if (input.originData && input.originData.conversation_id) {
                            queries.push(fileDao.entityInfo('ms_teams_conversation', input.originData.conversation_id));
                            conversationInfo = queries.length - 1;
                        }
                        if (input.originData && input.originData.actor_id) {
                            queries.push(fileDao.entityInfo('ms_teams_user', input.originData.actor_id));
                            userInfo = queries.length - 1;
                        }
                        $q.allSettled(queries).then(function (respes) {
                            input.entityInfo = respes[0].value && respes[0].value.data || {};
                            input.resolvers = {
                                team_id: {},
                                conversation_id: {},
                                actor_id: {}
                            };
                            if (teamInfo) {
                                input.resolvers.team_id = respes[teamInfo].value && respes[teamInfo].value.data || {};
                            }
                            if (conversationInfo) {
                                input.resolvers.conversation_id = respes[conversationInfo].value && respes[conversationInfo].value.data || {};
                            }
                            if (userInfo) {
                                input.resolvers.actor_id = respes[userInfo].value && respes[userInfo].value.data || {};
                            }
                            // meta-info logic
                            var metaInfo = {
                                key: {},
                                value: {},
                                pair: { class: 'file-meta-data' },
                                args: {
                                    beautifyKey: true,
                                    whiteList: [
                                        'create_time',
                                        'importance',
                                        {
                                            key: 'team_id',
                                            type: 'resolver',
                                            resolverEntity: 'ms_teams_team',
                                            resolverKey: 'name'
                                        },
                                        {
                                            key: 'conversation_id',
                                            type: 'resolver',
                                            resolverEntity: 'ms_teams_conversation',
                                            resolverKey: 'name'
                                        },
                                        {
                                            key: 'actor_id',
                                            type: 'resolver',
                                            resolverEntity: 'ms_teams_user',
                                            resolverKey: 'display_name'
                                        },
                                        {
                                            key: 'web_url',
                                            hiddenPairAny: { value: false }
                                        },
                                        {
                                            key: 'is_external',
                                            hiddenPairAny: { value: false }
                                        },
                                        {
                                            key: 'is_deleted',
                                            hiddenPairAny: { value: false }
                                        }
                                    ]
                                }
                            };
                            metaInfo.args.buttons = [];
                            if (sideMenuManager.currentUser().view_private_data && feature.ShowChatMessagesBody) {
                                metaInfo.args.buttons.push({
                                    label: 'View message text',
                                    'class': 'btn btn-blue',
                                    advanced: false,
                                    onClick: function () {
                                        var noConfirmViewMsgData = window.localStorage.getItem('view-msg-data-no-confirm');
                                        if (noConfirmViewMsgData) {
                                            return viewMessageData(id);
                                        }
                                        return modals.confirm({
                                            title: 'Warning',
                                            message: warningMsg,
                                            okText: 'Ok',
                                            remember: 'Don\'t show this message again'
                                        }).then(function (data) {
                                            if (data.remember) {
                                                window.localStorage.setItem('view-msg-data-no-confirm', true);
                                            }
                                            return viewMessageData(id);
                                        });
                                    }
                                });
                            }
                            metaInfo.data = metaInfoConverter(input, metaInfo.args);
                            $scope.model.metaInfo = metaInfo;
                            // actions
                            if ($scope.model.actionsWidget) {
                                $scope.model.actionsWidget.entityData = input.originData;
                            } else {
                                $scope.model.actionsWidget = {
                                    type: 'actions',
                                    logic: {
                                        name: 'remediationActionsLogic',
                                        updateTick: 30000,
                                        entityType: 'ms_teams_message',
                                        entityDataSlave: true
                                    },
                                    'class': 'file-info-actions-widget wide-250-buttons',
                                    wrapper: { type: 'none' },
                                    actions: rolesManager.isActionAllowed([
                                        'admin',
                                        'user',
                                        'operations'
                                    ]) ? [{
                                            autoId: 'profile_manual_action_btn_ms_teams_message_tombstone',
                                            actionType: 'ms_teams_message_tombstone',
                                            hiddenEntityAny: {
                                                is_deleted: true,
                                                is_tombstoned: true
                                            }
                                        }] : [],
                                    entityData: input.originData
                                };
                            }
                        });
                        if (restoreUpdateTickAfter && restoreUpdateTickAfter.isBefore(moment())) {
                            restoreUpdateTickAfter = null;
                            updateWidget = restartUpdating(updateWidget, updateTick);
                        }
                    }, function (err) {
                        console.log('Error in ms_teams message info:', err);
                    });
                };
                function copyToClipboard(content) {
                    var tempText = document.createElement('textarea');
                    document.body.appendChild(tempText);
                    tempText.value = content;
                    tempText.select();
                    document.execCommand('copy');
                    document.body.removeChild(tempText);
                }
                function viewMessageData(id) {
                    return commonDao.getEntityMessageBody('ms_teams_message', id).then(function (response) {
                        var messageData = response.data.message_text || '';
                        return modals.widget({
                            panel: {
                                type: 'info',
                                wrapper: {
                                    type: 'widget-panel',
                                    title: 'Message content',
                                    class: 'avanan white-body overflow-auto max-height-500'
                                },
                                lines: [{
                                        text: messageData,
                                        class: 'email-header'
                                    }]
                            },
                            addCloseX: 'true',
                            actionButtons: [{
                                    label: 'Copy to clipboard',
                                    click: function () {
                                        copyToClipboard(messageData);
                                    }
                                }]
                        }, 'lg');
                    }, function () {
                        var alertMessage = 'Message is unavailable';
                        modals.alert(alertMessage, { title: ' ' });
                    });
                }
                $scope.mainQueueDebug = mainQueueTroubleshootingHelper.button();
                updateWidget = $interval(function () {
                    $scope.loadData();
                }, updateTick);
                widgetPolling.on('remediationActionPerformed', function () {
                    restoreUpdateTickAfter = moment().add(30, 'seconds');
                    updateWidget = restartUpdating(updateWidget, 3000);
                });
                $scope.$on('$locationChangeStart', function () {
                    if (updateWidget) {
                        $interval.cancel(updateWidget);
                    }
                });
            }
        };
    }]);
}());